var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 39,
    viewBox: "0 0 51 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5909 38.8081V18.8211L5.47991 13.1503L0 10.0034V35.2809C0 37.2325 1.55889 38.8081 3.47736 38.8081H11.5909Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4091 38.8081H47.5226C49.4469 38.8081 51 37.2267 51 35.2809V10.0037L44.7931 13.608L39.4091 18.8211V38.8081Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5909 18.8211L10.7594 11.0116L11.5909 3.53711L25.5 14.1184L39.409 3.53711L40.3392 10.608L39.409 18.8211L25.5 29.4024L11.5909 18.8211Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4091 3.53702V18.821L51 10.0033V5.3005C51 0.938767 46.0913 -1.54774 42.6547 1.06809L39.4091 3.53702Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0032L5.33089 14.0588L11.5909 18.8208V3.53686L8.34527 1.06794C4.90277 -1.54809 0 0.938615 0 5.30015V10.003V10.0032Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 39,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.08732f4eba4c0ce40c47a950fcfb80aa.svg";
export { ForwardRef as ReactComponent };